const Prism = require('prismjs');
import(/* webpackMode: "eager" */ 'prismjs/plugins/autoloader/prism-autoloader');
import(/* webpackMode: "eager" */ 'prismjs/plugins/keep-markup/prism-keep-markup');
import(/* webpackMode: "eager" */ 'prismjs/plugins/file-highlight/prism-file-highlight');
import(/* webpackMode: "eager" */ 'prismjs/plugins/line-numbers/prism-line-numbers');
import(/* webpackMode: "eager" */ 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace');
import(/* webpackMode: "eager" */ 'prismjs/plugins/toolbar/prism-toolbar');
import(/* webpackMode: "eager" */ 'prismjs/plugins/download-button/prism-download-button');
import(/* webpackMode: "eager" */ 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard');

(function () {
	if (typeof Prism === 'undefined' || typeof document === 'undefined') {
		return;
	}
	if (Prism.plugins.NormalizeWhitespace) {
		Prism.plugins.NormalizeWhitespace.setDefaults({
			// 'remove-trailing': true,
			// 'remove-indent': true,
			// 'left-trim': true,
			// 'right-trim': true,
			// 'break-lines': 80,
			indent: 2,
			'remove-initial-line-feed': false,
			'tabs-to-spaces': 2,
		});
	}

	// if (Prism.plugins.toolbar) {
	// 	Prism.plugins.toolbar.registerButton('hello-world', {
	// 		text: 'Hello World!', // required
	// 		onClick: function (env) {
	// 			// optional
	// 			alert('This code snippet is written in ' + env.language + '.');
	// 		},
	// 	});
	// }
})();
